import React, { useEffect, useState } from "react";
import { IDS } from "@/constants/testIds";

const Footer = () => {
  const [time, setTime] = useState("");
  useEffect(() => {
    const tick = () => {
      const now = new Date();
      const hh = String(now.getUTCHours()).padStart(2, "0");
      const mm = String(now.getUTCMinutes()).padStart(2, "0");
      const ss = String(now.getUTCSeconds()).padStart(2, "0");
      setTime(`${hh}:${mm}:${ss} UTC`);
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <footer
      data-testid={IDS.footer}
      className="relative border-t border-[rgba(0,255,65,0.18)] bg-black"
    >
      <div className="mx-auto max-w-[1280px] px-6 lg:px-10 pt-16 pb-10">
        <div className="grid gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="font-mono text-xs uppercase tracking-[0.3em] text-zinc-500">
              // aetheria.sh
            </div>
            <div className="mt-4 font-mono text-3xl sm:text-4xl text-white tracking-tighter leading-tight">
              build the chain.
              <br />
              <span className="text-[#00FF41]">we run the metal.</span>
            </div>
            <div className="mt-6 text-sm text-zinc-400 max-w-md">
              Senior blockchain engineering studio. Solana, Rust, EVM L2s,
              validator infrastructure, audits.
            </div>
          </div>

          <div className="md:col-span-3">
            <FooterCol
              title="navigate"
              links={[
                ["#services", "Services"],
                ["#process", "Process"],
                ["#stack", "Tech Stack"],
                ["#contact", "Contact"],
              ]}
            />
          </div>

          <div className="md:col-span-4">
            <div className="text-[11px] uppercase tracking-[0.3em] text-zinc-500">
              /reach
            </div>
            <a
              href="mailto:info@aetheria.sh"
              className="mt-4 inline-block font-mono text-[#00FF41] link-line"
            >
              info@aetheria.sh
            </a>
          </div>
        </div>

        <div className="mt-14 hairline" />

        <div className="mt-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-[11px] uppercase tracking-[0.28em] text-zinc-500">
          <div>
            © {new Date().getFullYear()} aetheria labs · all rights reserved
          </div>
          <div className="flex items-center gap-4">
            <span className="inline-flex items-center gap-2">
              <span className="w-1.5 h-1.5 bg-[#00FF41] inline-block" />
              system: nominal
            </span>
            <span className="text-zinc-600">·</span>
            <span className="font-mono normal-case tracking-normal text-zinc-400">
              {time}
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

const FooterCol = ({ title, links }) => (
  <div>
    <div className="text-[11px] uppercase tracking-[0.3em] text-zinc-500">
      /{title}
    </div>
    <ul className="mt-4 space-y-2.5">
      {links.map(([href, label]) => (
        <li key={href}>
          <a
            href={href}
            className="text-sm text-zinc-300 hover:text-[#00FF41] link-line"
          >
            {label}
          </a>
        </li>
      ))}
    </ul>
  </div>
);

export default Footer;
